import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../../../../styles'
import classNames from 'classnames'
import { ModelDoc } from '../docs_model'
import { FormattedMessage } from 'react-intl'
import TableDoc from './TableDoc'
import ListDoc from './ListDoc'

const useStyle = makeStyles((theme) => ({
		...styles(theme),
		docsListContainer: {
			padding: '0px 5%'
		},
		docsNoResult: {
			display: 'flex',
			justifyContent: 'center',
			textAlign: 'center',
			padding: '5% 0px'
		}
	}
))

interface AcceptingProps {
	docs: Array<ModelDoc>,
	isLargeScreen: boolean
}

type DocsListProps = AcceptingProps

const DocumentBody: React.FC<DocsListProps> = (
	{
		docs,
		isLargeScreen
	}
) => {
	const classes = useStyle()

	const docsNoResult = classNames(
		isLargeScreen ? classes.title4 : classes.text4,
		classes.colorBlue,
		classes.docsNoResult
	)

	//Check if docs is empty
	const isDocsEmpty = (docs: Array<ModelDoc>) => {
		return docs.length <= 0
	}

	return (
		<div className={classes.docsListContainer}>
			{isDocsEmpty(docs) ?
				<span className={docsNoResult}>
                    <FormattedMessage
	                    id="contracts.document.emptyDocs"
	                    defaultMessage="Vous ne disposez d'aucun document correspondant à votre sélection"
	                    description="Contracts filter no result"
                    />
				</span>
				:
				isLargeScreen ?
					<TableDoc docs={docs} />
					:
					<ListDoc docs={docs} />
			}
		</div>
	)
}

export default DocumentBody